// Country options for billing address (2-letter ISO code + display label).
// Belgium first (default). Extend as needed.
export const COUNTRY_OPTIONS: { code: string; label: string }[] = [
  { code: 'BE', label: 'Belgique (BE)' },
  { code: 'FR', label: 'France (FR)' },
  { code: 'LU', label: 'Luxembourg (LU)' },
  { code: 'NL', label: 'Pays-Bas (NL)' },
  { code: 'DE', label: 'Allemagne (DE)' },
  { code: 'CH', label: 'Suisse (CH)' },
  { code: 'IT', label: 'Italie (IT)' },
  { code: 'ES', label: 'Espagne (ES)' },
  { code: 'PT', label: 'Portugal (PT)' },
  { code: 'AT', label: 'Autriche (AT)' },
  { code: 'GB', label: 'Royaume-Uni (GB)' },
];

const NAME_TO_CODE: Record<string, string> = {
  BELGIQUE: 'BE', BELGIE: 'BE', BELGIUM: 'BE',
  SUISSE: 'CH', SWITZERLAND: 'CH', CHE: 'CH',
  FRANCE: 'FR', LUXEMBOURG: 'LU', 'PAYS-BAS': 'NL', NEDERLAND: 'NL',
  ALLEMAGNE: 'DE', DEUTSCHLAND: 'DE', ITALIE: 'IT', ITALIA: 'IT',
  ESPAGNE: 'ES', 'ROYAUME-UNI': 'GB', BULGARIE: 'BG', SERBIE: 'RS',
  PORTUGAL: 'PT', AUTRICHE: 'AT',
};

/**
 * Normalize a raw `pays` value (FM data: codes, names, junk) to a 2-letter ISO code.
 * Falls back to 'BE'. Mirrors the backend normalizeCountryCode.
 */
export const toCountryCode = (pays?: string | null): string => {
  if (!pays || typeof pays !== 'string') return 'BE';
  const firstToken = pays.trim().split(/\s+/)[0] || '';
  const letters = firstToken.replace(/[^A-Za-z]/g, '').toUpperCase();
  if (letters.length === 2) return letters;
  const named = pays.trim().toUpperCase().replace(/\s+/g, ' ');
  return NAME_TO_CODE[named] || NAME_TO_CODE[letters] || 'BE';
};
